import React from 'react';
import { ServiceIllustration } from './ServiceIllustration';

export function Banner() {
  return (
    <div className="relative overflow-hidden z-10">
      {/* Background with gradient and pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-primary-900 to-blue-900"></div>
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=2000')] bg-cover bg-center opacity-10"></div>
      
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -right-20 w-40 h-40 sm:w-80 sm:h-80 bg-primary-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-20 -left-20 w-40 h-40 sm:w-80 sm:h-80 bg-blue-500/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 text-white/80 text-xs sm:text-sm font-medium mb-4 sm:mb-6">
            <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-green-400 rounded-full animate-pulse"></div>
            Trusted by 10,000+ Aviation Professionals
          </div>
          
          <h1 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            <span className="block">Everything You Need,</span>
            <span className="block bg-gradient-to-r from-primary-300 via-blue-300 to-primary-300 bg-clip-text text-transparent">
              Right Where You Land
            </span>
          </h1>
          
          <p className="text-sm sm:text-lg lg:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed px-4">
            Connect with verified aviation service providers worldwide. From ground handling to aircraft maintenance.
          </p>
        </div>
        
        <ServiceIllustration />
        
        {/* Call to action */}
        <div className="text-center mt-8 sm:mt-12">
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <button className="group relative px-6 py-3 sm:px-8 sm:py-4 bg-gradient-to-r from-primary-500 to-blue-600 text-white font-semibold rounded-xl sm:rounded-2xl shadow-2xl hover:shadow-primary-500/25 transition-all duration-300 hover:scale-105">
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl sm:rounded-2xl"></div>
              <span className="relative z-10 text-sm sm:text-base">Find Services Now</span>
            </button>
            
            <button className="group px-6 py-3 sm:px-8 sm:py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-xl sm:rounded-2xl border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105">
              <span className="text-sm sm:text-base">List Your Service</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}